import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { getSchema, uiSchema } from './Schema';

export default class AnnouncementEditor extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { formData: {} };
  }

  componentDidMount() {
    this.setupFormData();
  }

  componentDidUpdate() {
    this.setupFormData();
  }

  onSubmit = ({ formData }) => {
    const list = formData.limitToList || [];
    const announcement = {
      ...this.state.formData,
      ...formData,
      limitTo: Object.assign({}, ...list.map(d => ({ [d]: true }))),
    };
    this.props.onSave(announcement);
  };

  setupFormData = () => {
    const { announcement } = this.props;
    announcement.limitToList = Object.keys(announcement.limitTo);
    this.setState({ formData: this.props.announcement });
  };

  render() {
    const { fetching, dealers, history } = this.props;

    return (
      <div className="announcement-list-container">
        <Form
          schema={getSchema(dealers)}
          uiSchema={uiSchema}
          formData={this.state.formData}
          onSubmit={this.onSubmit}
          enctype="multipart/form-data"
        >
          <Button
            bsClass="btn btn-primary btn-large"
            disabled={fetching}
            type="submit"
          >
            Save
          </Button>
        </Form>
        <Button onClick={() => history.goBack()}>Cancel</Button>
      </div>
    );
  }
}

AnnouncementEditor.propTypes = {
  fetching: PropTypes.bool,
  announcement: PropTypes.object,
  history: PropTypes.object,
  onSave: PropTypes.func,
  dealers: PropTypes.array,
};
